import { render } from "./RemoveModal.vue?vue&type=template&id=2007978c&scoped=true"
import script from "./RemoveModal.vue?vue&type=script&lang=js"
export * from "./RemoveModal.vue?vue&type=script&lang=js"

import "./RemoveModal.vue?vue&type=style&index=0&id=2007978c&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2007978c"]])

export default __exports__